import { render, staticRenderFns } from "./DealLinksList.vue?vue&type=template&id=41fa6aae&scoped=true&"
import script from "./DealLinksList.vue?vue&type=script&lang=js&"
export * from "./DealLinksList.vue?vue&type=script&lang=js&"
import style0 from "./DealLinksList.vue?vue&type=style&index=0&id=41fa6aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fa6aae",
  null
  
)

export default component.exports